<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
  
</template>

<script>
var moment = require("moment");
import EmptyLayout from "@/layouts/EmptyLayout";
import UserLayout from "@/layouts/UserLayout";
import AdminLayout from "@/layouts/AdminLayout";
import ThankLayout from "@/layouts/ThankLayout";
export default {
  components: { EmptyLayout, UserLayout, AdminLayout, ThankLayout },
  computed: {
    layout() {
      return (this.$route.meta.layout || "empty") + "-layout";
    }
  },
  created: function() {
    moment.locale(navigator.language.split('-')[0]);
  },
};
</script>

<style lang="scss">
#app {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.arrow-back {
  text-align: center;
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  text-transform: uppercase;
  color: #0D1F3C;
}
.privacy-text {
  text-align: center;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 24px;
  text-transform: uppercase;
  cursor: pointer;
  a {
    color: #727C9B;
  }
}
.logo {
  display: flex;
  align-items: center;
  span {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    margin-left: -20px;
  }
}
</style>
